module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAH5JREFUKFNjZCARMJKonoFOGgQUFAR4GDjW///9J/bp0ztPkJ0pLa0iw8jKsvgLw4/ADw8efIA7SUZBs5yRkSHl36/fjjBNIMVMbKz7//9nmPPkwfVOkEEofkDWBJJEV4yhASQA0wRiI5sMcybWUAJpAimAOQPZT3QKVlJiGwCihzQNP/utPgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images2/down.png
// module id = PIEz
// module chunks = 1